export default __webpack_public_path__ + "static/media/1782.b39b7a00.png";